import axios from "axios";

export function getHttpErrorStatus(error: unknown): number {
  if (axios.isAxiosError(error) && error.response?.status) {
    return error.response.status;
  }
  return 500;
}
